import React,{useState, useEffect} from 'react';
import Button from '@material-ui/core/Button';
import {Tools} from './Tools';
import "./Dial.scss";

interface Props {
    score:number,
    title:string,
    next():void,
}

interface Pos {
    x: number,
    y: number,
}

const Roll = (props:Props)=> {
    const defCircles:Pos[] = [];
    const words = ["終","結","了","締","幕","完","閉"];
    const max = words.length;
    const per = Math.PI*2/max;

    const [states,setStates] = useState({
        isEnd: false,
        words:Tools.shuffle(words),
        circles: defCircles,
        arm: 40,
        rad: 0,
    })
    const update = ()=>{
        let circles = defCircles;
        const st = max*states.rad;
        for( let i=0 ; i<max ; i++ ){
            const angle = per * (i+st);
            const x = Math.floor(states.arm * Math.cos(angle) * 100)/100;
            const y = Math.floor(states.arm * Math.sin(angle) * 100)/100;
    
            circles.push({
                x:x,
                y:y,
            });
        }
        let arm = states.arm-1;
        if( arm<0 ){
            arm = 0
        }
        if( states.arm>0 ){
            setStates({...states,circles:circles,arm:arm,rad:states.rad+0.05});
        } else {
            setStates({...states,circles:circles,arm:0,isEnd:true});
        }
    }

    //let circles = defCircles;
    let t = 50;
    if( states.arm===40 ){
        t = 1;
    }
    if( states.arm===39 ){
        t = 500;
    }
    const tid:NodeJS.Timeout = setTimeout( ()=>{
        update();
    },t);    

    useEffect( ()=>{
        //update();
        return ()=>{
            clearTimeout(tid);
        }
    });

    //console.log("roll");
    const score = Tools.score(props.score);
    
    return (
        <div id="dial">
            <div className="emptyScr fadein">
                {props.title}
            </div>
            <div className="dialBoard fadein">
                <div className="content">
                    {!states.isEnd ? (
                    states.circles.map((circle:Pos,index:number)=>{
                        const key = "circle"+index;
                        const x = String(circle.x + 50) + "%"
                        const y = String(circle.y + 50) + "%"
                        const style:React.CSSProperties = {
                            "position":"absolute",
                            "top": y,
                            "left": x,
                        }
                        let cl = "dialBtn fadein-last";
                        return (
                            <button className={cl} key={key} style={style} data-value={states.words[index]}>{states.words[index]}</button>
                        )
                    })
                    ):(
                        <div className="score">
                            <div className="record">- 読了 -</div>
                            {score} <span>秒</span><br/>
                            <Button variant="outlined" color="primary" onClick={props.next}>記録を見る</Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Roll;
